import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/internal-request/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * To give nice look on Internal Request `status`.
 * It maps `status` to certain style.
 * @param {string} status Internal Request status
 */
const InternalRequestStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.REQUESTED]          : 'warning',
    [STATUS.DISPATCHED]         : 'success',
    [STATUS.ONGOING]            : 'primary',
    [STATUS.MARKED_FOR_RETURN]  : 'info',
    [STATUS.PARTIALLY_RETURNED] : 'warning',
    [STATUS.RETURNED]           : 'success',
    [STATUS.COMPLETED]          : 'success',
    [STATUS.CANCELLED]          : 'danger'
  }

  const color = colorMap[status]

  return <StatusBadge color={ color } label={ status } />
}

InternalRequestStatusBadge.propTypes = propTypes

export default InternalRequestStatusBadge
